import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiRowsBold } from 'react-icons/pi';
import './EmptyPlaceholder.scss';

export interface IEmptyPlaceholderProps {
  icon?: ReactNode;
  text?: ReactNode;
}

const EmptyPlaceholder = ({ icon, text }: IEmptyPlaceholderProps) => {
  const { t } = useTranslation();
  return (
    <div className='empty-placeholder'>
      {icon ?? <PiRowsBold />} <p>{text ?? t('table.empty')}</p>
    </div>
  );
};

export default EmptyPlaceholder;
